var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgVrbo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 610 562",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M308.91 405.33L323.69 374.12L273.36 116.77C259.3 44.3195 276.15 12.7898 332.99 1.83984V0.910156H280.49C265.29 8.45016 233.049 31.2902 251.139 116.66L308.91 405.33Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.14 467.55L293.82 436.44L227.78 115.11C215.38 52.7904 220.75 20.3398 241.32 1.83984V0.910156H205.66C194.81 24.1602 191.5 47.5197 204.01 109.22L279.14 467.55ZM248.76 529.56L263.43 498.76L180.96 108.4C166.39 47.6204 169.69 19.9302 175.58 0.910156H144.06C143.75 33.6702 147.99 66.4296 156.67 98.0596L248.76 529.56ZM115.23 0.910156H78.0195V1.83984C94.5595 21.9898 99.52 46.6896 112.75 101.06L211.76 561.29H234.08L135.07 99.6104C126.49 67.1604 119.88 34.1902 115.23 0.910156ZM40.9199 0.910156H1.12012V1.83984C37.4001 16.1998 55.2804 43.9 69.6504 108.5L167.52 561.08H189.85L91.25 105.71C74.3 26.64 56.4199 12.0702 40.9199 0.910156ZM547.14 0.910156C500.22 28.3002 472.31 79.0397 413.92 204.93L415.36 205.75C482.85 79.04 521.4 28.6104 608.53 2.36035V0.910156H547.14ZM410.61 202.45L412.06 203.48C467.56 72.6405 482.03 36.0498 504.66 1.83984V0.910156H459.81V2.15039C464.35 54.6504 446.89 102.92 410.61 202.45Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M407.61 200.48L409.06 201.41C444.3 84.2102 455.67 32.4302 424.56 0.910156H380.84V1.83984C430.35 19.4098 440.58 69.5305 407.61 200.48Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVrbo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vrbo.56c69a73.svg";
export { ForwardRef as ReactComponent };